export default __webpack_public_path__ + "static/media/Oracle.c24caa8a.svg";